import { bs58 } from '@coral-xyz/anchor/dist/cjs/utils/bytes'
import { PublicKey } from '@solana/web3.js'

export const solanaAddressToBytes32 = (address: string): `0x${string}` => {
    const decoded = bs58.decode(address)
    return `0x${Buffer.from(decoded as Uint8Array)
        .toString('hex')
        .padStart(64, '0')}`
}

export const solanaBytes32ToAddress = (bytes32: `0x${string}`): string => {
    const bytes = Buffer.from(bytes32.slice(2), 'hex')
    return bs58.encode(bytes)
}

export const isValidSolanaBytes32Address = (bytes32: string): boolean => {
    if (bytes32.length !== 66) {
        return false
    }
    try {
        const address = solanaBytes32ToAddress(bytes32 as `0x${string}`)
        new PublicKey(address)
        return true
    } catch {
        return false
    }
}
